/* ==============================================================================================
 * [ACCESS] CREDIT DERIVATIVES / 144A SEARCH RESULTS TABLE
 * ============================================================================================== */

var Sushi, CGS;

(function (Sushi, CGS) {
	"use strict";

	var apiEndpoint = "/json/access/creditDerivativesSearchResults.json";
	var tableElement = document.querySelector("#creditDerivativesSearchResultsTable");

	if (!tableElement) {
		return;
	}

	CGS.table(tableElement, {
		ajax: apiEndpoint,
		columns: [
			{
				data: "redEntityName",
				className: "c-table__cell",
				searchable: true,
			},
			{
				data: "redCode",
				className: "c-table__cell",
				searchable: true,
			},
			{
				data: "cusipIssuer",
				className: "c-table__cell",
				searchable: true,
			},
		],
		columnDefs: [],
		initComplete: CGS.createRetractTableWrapper,
	});

})(Sushi || (Sushi = {}), CGS || (CGS = {}));
